export default "__VITE_ASSET__BnU04sz$__"